// extracted by mini-css-extract-plugin
export var assigneeBadge = "_mf-0";
export var assigneeDetails = "_mf-1";
export var assigneeInfo = "_mf-2";
export var dropdownContainer = "_mf-4";
export var dropdownImage = "_mf-5";
export var editAssigneeInfo = "_mf-3";
export var editAssigneeModalContainer = "_mf-6";
export var hidden = "_mf-8";
export var input = "_mf-7";